import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_14: FaireProductEntity = {
  token: "catalog_prod_prod-14",
  type: "product",
  name: "Lumbar Pillow - Raggy Applique Celebrate - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 53.88,
  msrpDollars: 134.7,
  sku: "CO0014",
  caseSize: 6,
  material: "Glass",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 236,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_gift-wrapping"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
